import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <svg
        ref={ref}
        width='280'
        height='467'
        viewBox='0 0 280 467'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M1.5 150.164V139.999C1.5 72.3413 50.3828 14.5856 117.111 3.40396C132.265 0.864596 147.735 0.864595 162.889 3.40396C229.617 14.5856 278.5 72.3413 278.5 139.999V150.164M278.5 325.909C278.5 397.476 223.975 458.321 152.711 464.889C144.255 465.668 135.745 465.668 127.289 464.889C56.0246 458.321 1.5 397.476 1.5 325.909'
            stroke='white'
            strokeWidth='3'
        />
    </svg>
));

export const MaskIcon = styled(Icon)({});
